import
  React, {
  useEffect,
  useState
}	from 'react';

import
  PropTypes
from 'prop-types';

import {
  HandleRender,
  withScreenViewTagging
} from 'hocs';

import {
  Modal,
  OtpCard
} from 'components';

import {
  AuthProvider
} from 'providers';

import {
  ErrorKeys,
  OtpType,
  PopupConfig
} from '../constants';

import {
  getAuthToken
} from 'helpers';

import {
  BundleProvider
} from 'journeys';

const HandleOtpUI = (props) => {

  const [ state, setState ] = useState({
    isRequestLoading: true,
    isVerifyLoading: false,
    msisdnMasked: '',
    popupSettings: null,
    showPopup: false,
    showChildren: props.otpType === OtpType.Auth && !!getAuthToken(),
    isError: false,
    errorMessage: 'You have entered the OTP incorrectly three times. For your security, you are temporarily blocked from requesting new OTPs. Please try again in 24 hours.'
  });

  if (!state.showChildren) {

    HandleOtpUI.pageName = props.pageName;
    HandleOtpUI.tagViewData = props.tagViewData;
  }

  useEffect(() => {

    selectRequestOtp();
  }, []);

  const requestOtp = async (isResend = false) => {

    setState(prevState => ({
      ...prevState,
      isRequestLoading: true
    }));

    const response = await AuthProvider.requestOtp();

    if (isResend) {

      props?.onResendOtp?.(response);

      if (response?.ok && response?.result?.success) {

        setState(prevState => ({
          ...prevState,
          msisdnMasked: response?.result?.address,
          isRequestLoading: false,
          popupSettings: PopupConfig.OtpResent,
          showPopup: true
        }));

        return;
      }

      if (response?.result?.locked) {

        let lockedError = PopupConfig.OtpLockError;
        lockedError.message = response?.result?.message || lockedError.message;

        setState(prevState => ({
          ...prevState,
          isRequestLoading: false,
          popupSettings: lockedError,
          showPopup: true
        }));

        return;
      }

      setState(prevState => ({
        ...prevState,
        isRequestLoading: false,
        popupSettings: PopupConfig.OtpResendError,
        showPopup: true
      }));

      return;
    }

    props?.onRequestOtp?.(response);

    if (response?.ok && response?.result?.success) {

      setState(prevState => ({
        ...prevState,
        isRequestLoading: false,
        msisdnMasked: response?.result?.address
      }));

      return;
    }

    if (response?.result?.locked) {

      setState(prevState => ({
        ...prevState,
        isRequestLoading: false,
        isError: true,
        errorMessage: response?.result?.message || PopupConfig.OtpLockError?.text
      }));

      return;
    }

    setState(prevState => ({
      ...prevState,
      isRequestLoading: false,
      showChildren: true
    }));
  };

  const requestUserOtp = async (isResend = false) => {

    if (getAuthToken()) {

      setState(prevState => ({
        ...prevState,
        showChildren: true
      }));

      return;
    }

    setState(prevState => ({
      ...prevState,
      isRequestLoading: true
    }));

    const response = await AuthProvider.requestUserOtp();

    if (isResend) {

      props?.onResendOtp?.(response);

      if (response?.ok && response?.result?.successful) {

        setState(prevState => ({
          ...prevState,
          msisdnMasked: response?.result?.msisdnMasked,
          isRequestLoading: false,
          popupSettings: PopupConfig.OtpResent,
          showPopup: true
        }));

        return;
      }

      if (response?.result?.locked) {

        let lockedError = PopupConfig.OtpLockError;
        lockedError.message = response?.result?.message || lockedError.message;

        setState(prevState => ({
          ...prevState,
          isRequestLoading: false,
          popupSettings: lockedError,
          showPopup: true
        }));

        return;
      }

      setState(prevState => ({
        ...prevState,
        isRequestLoading: false,
        popupSettings: PopupConfig.OtpResendError,
        showPopup: true
      }));

      return;
    }

    props?.onRequestOtp?.(response);

    if (response?.ok && response?.result?.successful) {

      setState(prevState => ({
        ...prevState,
        msisdnMasked: response?.result?.msisdnMasked,
        isRequestLoading: false
      }));

      return;
    }

    if (response?.result?.locked) {

      setState(prevState => ({
        ...prevState,
        isRequestLoading: false,
        isError: true,
        errorMessage: response?.result?.message || PopupConfig.OtpLockError?.text
      }));

      return;
    }

    setState(prevState => ({
      ...prevState,
      isRequestLoading: false,
      showChildren: true
    }));
  };

  const verifyOtp = async (otp) => {

    setState(prevState => ({
      ...prevState,
      isVerifyLoading: true
    }));

    const response = await AuthProvider.verifyOtp(otp);

    props?.onVerifyOtp?.(response);

    if (response?.ok && response?.result) {

      setState(prevState => ({
        ...prevState,
        isVerifyLoading: false,
        showChildren: true
      }));

      return;
    }

    if (response?.code === 422) {

      setState(prevState => ({
        ...prevState,
        isVerifyLoading: false,
        popupSettings: PopupConfig.InvalidOtp,
        showPopup: true
      }));

      return;
    }

    setState(prevState => ({
      ...prevState,
      isVerifyLoading: false,
      showChildren: true
    }));
  };

  const verifyUserOtp = async (otp) => {

    setState(prevState => ({
      ...prevState,
      isVerifyLoading: true
    }));

    const response = await AuthProvider.verifyUserOtp(otp);

    props?.onVerifyOtp?.(response);

    if (response?.code === 401 || response?.code === 403) {

      setState(prevState => ({
        ...prevState,
        isVerifyLoading: false,
        popupSettings: PopupConfig.InvalidOtp,
        showPopup: true
      }));

      return;
    }

    setState(prevState => ({
      ...prevState,
      isVerifyLoading: false,
      showChildren: true
    }));
  };

  const verifyBundlesOtp = async (otp) => {

    setState(prevState => ({
      ...prevState,
      isVerifyLoading: true
    }));

    const response = await BundleProvider.verifyOtp(otp, props?.vasCode);

    props?.onVerifyOtp?.(response);

    if (response?.code === 422) {

      setState(prevState => ({
        ...prevState,
        isVerifyLoading: false,
        popupSettings: PopupConfig.InvalidOtp,
        showPopup: true
      }));

      return;
    }

    setState(prevState => ({
      ...prevState,
      isVerifyLoading: false,
      showChildren: true
    }));
  };

  const selectRequestOtp = (isResend = false) => {

    switch (props.otpType) {
      case OtpType.Auth:
        return requestUserOtp(isResend);

      case OtpType.Otp:
        return requestOtp(isResend);

      case OtpType.Bundles:
        return requestOtp(isResend);

      default:
        break;
    }
  };

  const selectVerifyOtp = (otp) => {

    switch (props.otpType) {
      case OtpType.Auth:
        return verifyUserOtp(otp);

      case OtpType.Otp:
        return verifyOtp(otp);

      case OtpType.Bundles:
        return verifyBundlesOtp(otp);

      default:
        break;
    }
  };

  const closePopup = () => {

    setState(prevState => ({
      ...prevState,
      showPopup: false
    }));
  };

  return (
    <>
      {
        state.showChildren

          ? props.children

          :
            <>
              { props.renderModal && !state.isError && <Modal/>}

              <HandleRender
                isLoading={false}
                isError={state.isError}
                error={{
                  type: ErrorKeys.Technical,
                  title: state.errorMessage
                }}>

                <OtpCard
                  onSubmitOtp={otp => selectVerifyOtp(otp)}
                  onResendOtp={() => selectRequestOtp(true)}
                  onClose={props.onClose}
                  subtitle={`We’ve sent a One-Time PIN (OTP) to ${state.msisdnMasked}. Please enter it below to continue:`}
                  isRequestLoading={state.isRequestLoading}
                  isVerifyLoading={state.isVerifyLoading}
                  popupText={state.popupSettings?.text}
                  popupTextColor={state.popupSettings?.textColor}
                  popupBackgroundColor={state.popupSettings?.backgroundColor}
                  showPopup={state.showPopup}
                  onClosePopup={closePopup}/>

              </HandleRender>
            </>
      }
    </>
  );
};

HandleOtpUI.propTypes = {
  otpType: PropTypes.string,
  children: PropTypes.element,
  pageName: PropTypes.string,
  tagViewData: PropTypes.object,
  onVerifyOtp: PropTypes.func,
  onResendOtp: PropTypes.func,
  onRequestOtp: PropTypes.func,
  onClose: PropTypes.func,
  onClosePopup: PropTypes.func,
  renderModal: PropTypes.bool
};

HandleOtpUI.defaultProps = {
  otpType: '',
  children: undefined,
  pageName: '',
  tagViewData: {},
  onVerifyOtp: () => {},
  onResendOtp: () => {},
  onRequestOtp: () => {},
  onClose: () => {},
  onClosePopup: () => {},
  renderModal: false
};

export const HandleOtp = withScreenViewTagging(HandleOtpUI);